import * as tfc from '@tensorflow/tfjs-core';
import * as blazeface from '@tensorflow-models/blazeface';
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';
import FaceDetection from '../../helpers/FaceDetection';

export const load = async () => {
  tfjsWasm.setWasmPath('/tfjs-backend-wasm.wasm');
};

const returnTensors = false;
const flipHorizontal = true;
const annotateBoxes = true;

export const init = async (data) => {
  const { backend, faceDetectionSettings } = data;

  await tfc.setBackend(backend);

  return await blazeface.load({
    // The maximum number of faces returned by the model
    maxFaces: faceDetectionSettings.maxFaces,
    // The width of the input image
    inputWidth: faceDetectionSettings.faceDetectionImageMinWidth,
    // The height of the input image
    inputHeight: faceDetectionSettings.faceDetectionImageMinHeight,
    // The threshold for deciding whether boxes overlap too much
    iouThreshold: faceDetectionSettings.iouThreshold,
    // The threshold for deciding when to remove boxes based on score
    scoreThreshold: faceDetectionSettings.scoreThreshold,
  });
};

export const detectFace = async (data, faceModel) => {
  const { imageDataToProcess, faceDetectionImageRatio, videoWidth, videoHeight, lastIndex } = data;

  let predictions = await faceModel.estimateFaces(
    // The image to classify. Can be a tensor, DOM element image, video, or canvas
    imageDataToProcess,
    // Whether to return tensors as opposed to values
    returnTensors,
    // Whether to flip/mirror the facial keypoints horizontally. Should be true for videos that are flipped by default (e.g. webcams)
    flipHorizontal,
    // Whether to annotate bounding boxes with additional properties such as landmarks and probability. Pass in `false` for faster inference if annotations are not needed
    annotateBoxes,
  );

  predictions = new FaceDetection().normalizePredictions(
    predictions,
    returnTensors,
    annotateBoxes,
    faceDetectionImageRatio,
    videoWidth,
    videoHeight,
  );

  return { predictions, lastIndex };
};
